import { io, Socket } from "socket.io-client";

let socket: Socket;

export const initializeSocket = (storeId: string) => {
  socket = io(import.meta.env.VITE_APP_BACKEND_URL.replace("/app", ""), {
    query: {
      storeId,
    },
  });

  return socket;
};

export const getSocket = () => socket;
